import { Image } from "antd"
import { Container } from "../components"
import colors4 from "../images/color4.png"
import colors from "../images/colors.jpg"
import colors2 from "../images/colors2.png"
import colors3 from "../images/colors3.png"
import { useTheme } from "styled-components"

const sectionBoxStyle: React.CSSProperties = {
    
    border: "1px solid #e0e0e0",
    borderRadius: 12,
    padding: "1.5em",
    marginBottom: "2em",
    boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
}

export function ColorPalette(): JSX.Element {
    const theme = useTheme()
    const themeObj = theme as Record<string, any>
    const colorKeys =
        themeObj && typeof themeObj === "object"
            ? Object.keys(themeObj).filter((key) => typeof themeObj[key] === "string" && themeObj[key].startsWith("#"))
            : []
    return (
        <Container>
            <div style={sectionBoxStyle}>
                <h1>Colors used in current theme</h1>
                <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: "3em" }}>
                    {colorKeys.map((key) => (
                        <div key={key} style={{ textAlign: "center" }}>
                            <div
                                style={{
                                    width: 60,
                                    height: 60,
                                    background: themeObj[key],
                                    border: "1px solid #ddd",
                                    borderRadius: 8,
                                    marginBottom: 8,
                                }}
                            />
                            <div style={{ fontSize: 12 }}>{key}</div>
                            <div style={{ fontSize: 11, color: "#888" }}>{themeObj[key]}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div style={sectionBoxStyle}>
                <h1>Reference 1</h1>
                <Image preview={false} src={colors4} />
                <div>
                    <a href="https://graphicmama.com/blog/website-color-schemes//">
                        https://graphicmama.com/blog/website-color-schemes//
                    </a>
                </div>
            </div>

            <div style={sectionBoxStyle}>
                <h1>Reference 2</h1>
                <Image preview={false} src={colors3} />
                <div>
                    <a href="https://happyaddons.com/best-website-color-schemes-for-web-design/">
                        https://happyaddons.com/best-website-color-schemes-for-web-design/
                    </a>
                </div>
            </div>

            <div style={sectionBoxStyle}>
                <h1>Reference 3</h1>
                <ul>
                    <li>TUFTS BLUE</li>
                    <li>FRENCH SKY BLUE</li>
                    <li>ALICE BLUEE</li>
                    <li>WHITE</li>
                    <li>COPPER</li>
                </ul>
                <Image preview={false} src={colors2} />
            </div>

            <div style={sectionBoxStyle}>
                <h1>Reference 4</h1>
                <ul>
                    <li>ONYX</li>
                    <li>TAUPE GRAY</li>
                    <li>WHITE SMOKE</li>
                    <li>QUEEN BLUE</li>
                    <li>MEDIUM TURQUOISE</li>
                </ul>
                <Image preview={false} src={colors} />
                <div>
                    <a href="https://graphicmama.com/blog/website-color-schemes/">
                        https://graphicmama.com/blog/website-color-schemes/
                    </a>
                </div>
                <div>
                    <a href="https://styled-components.com/docs/advanced">themes in styled components</a>
                </div>
            </div>
        </Container>
    )
}
